// Module
var code = `<div class="convert-doc">
<div class="main-layout">
    <!-- Left: Upload & Configure Panel -->
    <div class="config-panel">
        <div class="card h-100">
            <div class="card-header">
                <h5>Upload & Configure</h5>
            </div>
            <div class="card-body">
                    <!-- Upload Area -->
                    <div class="upload-area" id="uploadArea">
                        <input type="file" id="fileInput" accept=".txt,.ds,.ds.txt,.srt" style="display:none" />
                        <div class="upload-prompt">
                            <i class="upload-icon">📁</i>
                            <p>Drag & drop file here or click to browse</p>
                            <small class="text-muted">Supported: .txt, .ds, .srt</small>
                        </div>
                    </div>

                    <!-- Options Panel (shown after file upload) -->
                    <div class="options-panel" id="optionsPanel" style="display:none">
                        <div class="mb-3">
                            <label class="form-label">Current File</label>
                            <div class="alert alert-secondary" id="currentFile"></div>
                        </div>

                        <div class="mb-3">
                            <label for="sourceFormat" class="form-label">Source Format</label>
                            <select id="sourceFormat" class="form-select">
                                <option value="">Auto-detect</option>
                                <option value="Text">Plain Text</option>
                                <option value="SRT">SRT</option>
                                <option value="AvidDS">Avid DS</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label for="targetFormat" class="form-label">Target Format</label>
                            <select id="targetFormat" class="form-select" required>
                                <option value="">-- Select Target Format --</option>
                            </select>
                        </div>

                        <div class="mb-3" id="frameRateGroup" style="display:none">
                            <label for="frameRate" class="form-label">Frame Rate</label>
                            <select id="frameRate" class="form-select">
                                <option value="">Default (25fps)</option>
                            </select>
                        </div>

                        <div class="mb-3" id="modeGroup" style="display:none">
                            <label for="mode" class="form-label">Parser Mode</label>
                            <select id="mode" class="form-select">
                                <option value="">Default (AvidDS)</option>
                                <option value="AvidDS">Avid DS</option>
                            </select>
                        </div>

                        <div class="form-check mb-3">
                            <input type="checkbox" id="ignoreFrames" class="form-check-input" />
                            <label for="ignoreFrames" class="form-check-label">Ignore Frames</label>
                        </div>

                        <!-- Action Buttons -->
                        <div class="actions">
                            <button type="button" id="validateBtn" class="btn btn-outline-primary w-100 mb-2">
                                <span class="btn-text">Validate</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="convertBtn" class="btn btn-success w-100 mb-2">
                                <span class="btn-text">Convert</span>
                                <span class="spinner-border spinner-border-sm d-none" role="status"></span>
                            </button>
                            <button type="button" id="discardBtn" class="btn btn-outline-secondary w-100 mb-2" style="display:none">
                                Discard Result
                            </button>
                            <button type="button" id="downloadBtn" class="btn btn-primary w-100 mb-2" style="display:none">
                                Download Result
                            </button>
                            <button type="button" id="clearBtn" class="btn btn-outline-danger w-100">
                                Clear & Start Over
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Center & Right: Editors with validation at bottom -->
        <div class="editors-area">
            <!-- Top: Editors Row -->
            <div class="editors-row">
                <div class="editors-container" id="editorsContainer">
                <!-- Source Editor -->
                <div class="card editor-panel" id="editorCard" style="display:none">
                    <div class="card-header">
                        <h5>Source Document</h5>
                    </div>
                    <div class="card-body editor-body">
                        <doc-editor id="docEditor"></doc-editor>
                    </div>
                </div>

                <!-- Result Preview (always shown alongside source) -->
                <div class="card editor-panel result-preview" id="resultEditorCard" style="display:none">
                    <div class="card-header">
                        <h5>Converted Preview</h5>
                    </div>
                    <div class="card-body editor-body">
                        <doc-editor id="resultEditor"></doc-editor>
                    </div>
                    <div class="result-placeholder" id="resultPlaceholder">
                        <div class="text-center text-muted">
                            <p class="mb-2">💾</p>
                            <p>Converted document will appear here</p>
                        </div>
                </div>

                <!-- Placeholder -->
                <div class="card" id="placeholderCard">
                    <div class="card-body text-center text-muted">
                        <p class="lead">Upload a file to begin conversion</p>
                    </div>
                </div>
            </div>

            <!-- Bottom: Validation Panel (always visible, 30% height) -->
            <div class="validation-panel" id="validationPanel">
                <div class="panel-header">
                    <h6>Validation Messages</h6>
                    <div class="panel-badges" id="validationBadges"></div>
                </div>
                <div class="panel-content" id="validationMessages">
                    <div class="empty-state">
                        <p class="text-muted">No validation messages</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </div>
</div>
`;
// Exports
export default code;